import { withInstall, withNoopInstall } from '@jdesign-vue/utils'
import Timeline from './src/timeline'
import TimelineItem from './src/timeline-item.vue'

export const JdTimeline = withInstall(Timeline, {
  TimelineItem,
})
export default JdTimeline
export const JdTimelineItem = withNoopInstall(TimelineItem)

export * from './src/timeline'
export * from './src/timeline-item'
